<mat-form-field appearance="fill" class="full-width" [ngClass]="width&&'custom--width'">
  <mat-label *ngIf="placeholder">{{placeholder}}</mat-label>
  <input matInput [formControl]="control" [matAutocomplete]="auto" [readonly]="readonly ? true : null" #inputElement
    (focus)="onFocus()" />
  <mat-icon *ngIf="!readonly" mat-icon-button matSuffix (click)="openAutocomplete(inputElement)"
    aria-label="Toggle dropdown" [ngClass]="{ 'rotated': isPanelOpen }">arrow_drop_down</mat-icon>
  <mat-autocomplete [displayWith]="displayFn.bind(this)" #auto="matAutocomplete" (opened)="isPanelOpen = true"
    (closed)="isPanelOpen = false;onAutocompleteClosed()" (optionSelected)="onOptionSelected($event)">
    @for (option of filteredOptions | async; track option) {
    <mat-option [value]="option">{{displayFn(option)}}</mat-option>
    }
  </mat-autocomplete>
  <mat-error *ngIf="control.hasError('required')">
    {{error}}
  </mat-error>
</mat-form-field>